export default "__VITE_ASSET__DeYdtHMF__"